import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').factory('invoiceEditorService', ['$q', '$filter', 'leanLawApi', 'userService', 'accountingService', 'onboardService', 'leanLawAuth', 'alerts', function ($q, $filter, leanLawApi, userService, accountingService, onboardService, leanLawAuth, alerts) {
  var _me;
  var _users;
  var _domain;
  userService.me().then(me => {
    _me = me;
  });
  userService.list({
    status: 'all'
  }).then(users => {
    _users = users;
  });
  _domain = `${leanLawAuth.domain}/v1`;
  var _state = {
    format: {
      // what to include
      includeFixed: false,
      includeNone: false,
      includeHours: true,
      includeExpenses: true,
      includeExtra: true,
      // description
      includeMatter: false,
      includeUser: false,
      includeUserInExpenseDescription: false,
      includeCodes: false,
      separator: ': ',
      fixedDetail: false,
      fixedHideHours: false,
      // combining things
      combine: false,
      combineHours: true,
      combineMatters: false,
      combineTypes: false,
      combineBillable: false,
      // summaries
      summarizeTime: false,
      summaryAccount: false,
      summaryAccountMemo: false
    },
    config: {},
    invoice: null,
    onhold: [],
    init: {},
    query: {}
  };
  var zeroTotals = {
    hours: {
      billable: 0,
      fixed: 0,
      nonBillable: 0
    },
    amount: 0,
    discount: 0
  };
  function round2(n) {
    return Math.round(n * 100) / 100;
  }
  function setFormat(format, config) {
    // have to copy properties because if we assign by reference, it doesn't propagate properly.
    // properties propagate properly! say that 10 times fast!
    for (var prop in format) {
      if (format.hasOwnProperty(prop)) {
        _state.format[prop] = format[prop];
      }
    }
    if (config) {
      _state.config = config;
    }
  }
  function setConfig(config) {
    _state.config = config || {};
  }
  // me.company.settings.fees.services = percentage
  // .servicelabel = optional

  function Invoice() {
    this.invoiceDate = new Date().setHours(0, 0, 0, 0);
    this.due = new Date(new Date().getTime() + 24 * 60 * 60000 * 14);
    this.date = null; // is this used anywhere?

    this.billto = null;
    this.memo = {
      showMatterTotals: true,
      showCustomFields: true,
      showAccountTotals: true,
      showTrust: true
    };

    // Invoice groups
    this.groups = [];

    // Raw data loaded from API
    this.entries = [];
    this.expenses = [];

    // Totals
    this.totals = angular.copy(zeroTotals);

    // Set if one or more descriptions are truncated
    this.truncated = false;
    this.format = {};
  }
  Invoice.prototype.loadFromInvoice = function (invoice) {
    _.extend(this, invoice);
    if (this.created) {
      this.created = new Date(this.created);
    }
    if (this.invoiceDate) {
      // this.invoiceDate = new Date(this.invoiceDate);
      this.invoiceDate = new Date(this.invoiceDate).setHours(0, 0, 0, 0);
    }
    this.groups = invoice.groups.map(g => new Group().fromExisting(g));
    this.credit = !!this.groups.find(g => g.credit);
    if (!invoice.state.open && !invoice.state.closed) {
      this.$original = angular.copy(invoice);
      this.updateTotals();
      this.updateMemo();
    }
    this.ledes = invoice.client.codes && invoice.client.codes.ledes;
    return this;
  };
  Invoice.prototype.name = function () {
    var invoice = this;
    var invoiceName = _.uniq(_.map(invoice.entries, function (e) {
      return e.matter.name;
    }), false).join(', ');
    var clients = _.uniq(_.map(invoice.entries, function (e) {
      return e.matter.client.name;
    }), false);
    if (clients.length == 1) {
      invoiceName = clients[0] + ' (' + invoiceName + ')';
    }
    return invoiceName;
  };
  Invoice.prototype.setTrust = function (account, evergreen) {
    this.trust = {
      account,
      evergreen
    };
    if (this.$original) {
      this.$original.trust = angular.copy(this.trust);
    }
    if (!this.state || this.state.draft || this.state.approved) {
      // only update memo if we are staging, or in draft/approved
      this.updateMemo();
    }
  };
  Invoice.prototype.setAccountBalance = function (balance) {
    this.accountBalance = balance;
  };
  function trustMemo({
    trustBalance,
    invoiceBalance,
    accountBalance,
    evergreen,
    config
  }) {
    // The following logic is also in the back-end (TrustMemo in InvoiceCreator.cs)
    // so if updating, make sure to update there as well
    if (config.memoPattern.indexOf('{before}') > 0 || config.memoPattern.indexOf('{after}') > 0) {
      // legacy
      if (trustBalance >= invoiceBalance) {
        return replaceLegacy(config.memoPattern, invoiceBalance, trustBalance - invoiceBalance);
      }
      return replaceLegacy(config.memoPatternPartial, trustBalance, invoiceBalance - trustBalance);
    }
    var due = invoiceBalance + (accountBalance || 0);
    if (evergreen) {
      if (trustBalance >= due) {
        var trustAfter = trustBalance - due;
        var replenish = trustAfter < evergreen ? evergreen - trustAfter : 0;
        return replace(config.memoPatternEvergreen, 0, trustAfter, due, evergreen, replenish, replenish);
      }
      var accountAfter = due - trustBalance;
      return replace(config.memoPatternEvergreen, accountAfter, 0, trustBalance, evergreen, evergreen + accountAfter, evergreen);
    }
    if (trustBalance >= due) {
      return replace(config.memoPattern, 0, trustBalance - due, due);
    }
    return replace(config.memoPatternPartial, due - trustBalance, 0, trustBalance);
    function replace(pattern, accountAfter, trustAfter, trustPayment, evergreen, paymentRequired, replenish) {
      if (!pattern) return '';
      return pattern.replace('{InvoiceAmount}', $filter('amount')(invoiceBalance)).replace('{AmountDue}', $filter('amount')(due)).replace('{AccountBefore}', $filter('amount')(accountBalance)).replace('{AccountAfter}', $filter('amount')(accountAfter)).replace('{TrustBefore}', $filter('amount')(trustBalance)).replace('{TrustAfter}', $filter('amount')(trustAfter)).replace('{TrustPayment}', $filter('amount')(trustPayment)).replace('{TrustAfterSimple}', $filter('amount')(invoiceBalance > trustBalance ? 0 : trustBalance - invoiceBalance)).replace('{TrustPaymentSimple}', $filter('amount')(invoiceBalance > trustBalance ? trustBalance : invoiceBalance)).replace('{TrustEvergreen}', $filter('amount')(evergreen)).replace('{TrustEvergreenReplenish}', $filter('amount')(replenish)).replace('{PaymentRequired}', $filter('amount')(paymentRequired));
    }
    function replaceLegacy(pattern, payment, after) {
      if (!pattern) return '';
      return pattern
      // legacy
      .replace('{before}', $filter('amount')(trustBalance)).replace('{payment}', $filter('amount')(payment)).replace('{after}', $filter('amount')(after)).replace('{invoice}', $filter('amount')(invoiceBalance));
    }
  }
  Invoice.prototype.updateMemo = async function (date) {
    var invoice = this;
    var memo = invoice.memo;
    memo.memo = memo.note ? memo.note + '\n' : '';
    memo.trust = '';
    memo.matters = '';
    memo.accounts = '';
    memo.customFields = '';
    if (!memo.showTrust && !memo.showMatterTotals && !memo.showAccountTotals && !memo.showCustomFields) {
      return memo;
    }
    if (invoice.trust && invoice.trust.account && !invoice.trust.loading) {
      if (invoice.$original?.memo?.showTrust == undefined) {
        memo.showTrust = _me.company.settings?.isTrustMemoEnabled || true;
        return;
      }
      memo.trust = trustMemo({
        trustBalance: invoice.trust.account.balance,
        invoiceBalance: invoice.totals.amount - (invoice.discount || 0),
        accountBalance: invoice.accountBalance,
        evergreen: invoice.trust.evergreen,
        config: _state.config
      });
    }
    if (this.showMatterTotals()) {
      var matterGroups = _.groupBy(invoice.groups, g => g.matter ? g.matter.id : null);
      var groupIds = _.keys(matterGroups);
      if (groupIds.length > 1) {
        memo.matters += '\n' + _me.terms.Matter + ' Totals:\n';
        _.each(groupIds, function (id) {
          if (!id) return;
          var groups = matterGroups[id];
          if (!groups[0].matter) return;
          var total = _.reduce(groups, (sum, g) => sum + g.totals.amount, 0);
          memo.matters += '- ' + groups[0].matter.label + ': ' + $filter('currency')(total, '$', 2) + '\n';
        });
      }
    }
    if (this.showCustomFields()) {
      if (invoice.client?.clientCustomFieldDetails?.length) {
        memo.customFields += `${invoice.client?.label}\n`;
        invoice.client?.clientCustomFieldDetails?.forEach(customField => {
          memo.customFields += `${customField?.customField?.name}: ${customField?.value}\n`;
        });
      }
      if (invoice.matter?.matterCustomFieldDetails?.length) {
        memo.customFields += `\n${invoice.matter?.label}\n`;
        invoice.matter?.matterCustomFieldDetails?.forEach(customField => {
          memo.customFields += `${customField?.customField?.name}: ${customField?.value}\n`;
        });
      }
      if (invoice.matters?.length) {
        let pieces = invoice.matters.filter(matter => matter.matterCustomFieldDetails.length).map(matter => {
          let field = `\n${matter.label} \n`;
          matter.matterCustomFieldDetails.forEach(customField => {
            field += `${customField?.customField?.name}: ${customField?.value}\n`;
          });
          return field;
        });
        memo.customFields += pieces.join('--');
      }
    }
    let templateId = null;

    // single matter
    if (invoice.matter != null) {
      templateId = invoice.matter.invoiceTemplateId;
    }

    // multiple matters
    if (!templateId && invoice.matters != undefined && invoice.matters?.length) {
      templateId = invoice.matters[0]?.InvoiceTemplateId;
    }

    // default invoice template..
    if (!templateId) {
      const invoiceTemplateDefault = getDefaultInvoiceTemplates();
      templateId = invoiceTemplateDefault?.InvoiceTemplateId;
    }
    if (templateId) {
      let templateMemo = getInvoiceTemplatesById(templateId);
      this.memo.showAccountTotals.showAccountTotals = false;
      if (templateMemo) {
        memo.note = memo.note ? memo.note : `${templateMemo}\n`;
      }
    }
    if (this.showAccountTotals()) {
      var accountGroups = {};
      invoice.groups.forEach(g => g.lineItems.forEach(line => {
        if (line.account && line.hours && line.amount) {
          if (!accountGroups[line.account.id]) {
            accountGroups[line.account.id] = [];
          }
          accountGroups[line.account.id].push(line);
        }
      }));
      var sums = Object.keys(accountGroups).map(id => {
        let hours = _.reduce(accountGroups[id], (sum, l) => sum + l.hours, 0);
        return {
          id,
          hours: hours,
          amount: _.reduce(accountGroups[id], (sum, l) => sum + l.amount, 0),
          rate: _.reduce(accountGroups[id], (sum, l) => sum + l.hours * l.rate.amount, 0) / hours
        };
      }).sort((a, b) => b.amount - a.amount);
      if (sums.length) {
        memo.accounts += '\nHours Summary:\n';
        sums.forEach(s => {
          var user = _users.find(u => u.id == s.id);
          var name = user ? user.name + (user.initials ? ' (' + user.initials + ')' : '') : 'Unknown';
          var rate = s.rate;
          memo.accounts += `- ${name}: ${$filter('hoursDecimal')(s.hours)}h @${$filter('currency')(rate, '$', 2)} = ${$filter('currency')(s.amount, '$', 2)}\n`;
        });
      }
    }
    var memos = [];
    if (memo.note) {
      memos.push(memo.note);
    }
    if (memo.showTrust) {
      memos.push(memo.trust);
    }
    if (memo.showMatterTotals) {
      memos.push(memo.matters);
    }
    if (memo.showCustomFields) {
      memos.push(memo.customFields);
    }
    if (memo.showAccountTotals) {
      memos.push(memo.accounts);
    }
    memo.memo = memos.join('\n\n');
    return memo;
  };
  Invoice.prototype.showMatterTotals = function () {
    if (_state.init.matter) return false;
    if (this.id) {
      return !this.format.combineMatters;
    }
    return !_state.format.combineMatters;
  };
  Invoice.prototype.showCustomFields = function () {
    if (this.id) {
      return this.memo.showCustomFields;
    }
    return true;
  };
  Invoice.prototype.showAccountTotals = function () {
    if (this.id) {
      return this.memo.showAccountTotals;
    }
    return _state.format.summaryAccountMemo;
  };
  async function getInvoiceTemplatesById(templateId) {
    try {
      const path = `${_domain}/invoiceTemplates/${templateId}`;
      const {
        data
      } = await $http.get(path);
      return data.memo;
    } catch (error) {
      alerts.error(error.response?.data?.message);
    }
  }
  async function getDefaultInvoiceTemplates() {
    try {
      const path = `${_domain}/invoiceTemplates`;
      const {
        data
      } = await $http.get(path);
      const invoiceTemplateDefault = data.find(template => template.default);
      return invoiceTemplateDefault;
    } catch (error) {
      alerts.error(error.response?.data?.message);
    }
  }
  Invoice.prototype.updateTotals = function () {
    this.totals = angular.copy(zeroTotals);

    // Ensure group totals are calculated on first run
    this.groups.forEach(function (group) {
      group.updateTotals();
    });

    // Calculate computed amounts
    var billableServices = this.groups.reduce((accum, g) => {
      var amount = g.lineItems.find(li => li.hasOwnProperty('expenses') || li.hasOwnProperty('computed')) ? 0 : g.subtotal;
      return accum + amount;
    }, 0);
    this.groups.filter(group => group.lineItems.some(li => li.hasOwnProperty('computed'))).forEach(group => {
      group.lineItems.filter(li => li.hasOwnProperty('computed')).forEach(li => {
        if (typeof li?.computed?.settings?.services !== 'undefined') {
          li.amount = Math.round(billableServices * (li.computed.settings.services ?? 0)) / 100;
        }
      });
      group.subtotal = group.lineItems.reduce((sum, i) => sum + i.amount, 0);
    });
    var totals = this.totals;
    this.groups.forEach(function (group) {
      var groupTotals = group.updateTotals();
      totals.hours.billable += groupTotals.hours.billable;
      totals.hours.nonBillable += groupTotals.hours.nonBillable;
      totals.hours.fixed += groupTotals.hours.fixed;
      totals.amount += groupTotals.amount;
      totals.discount += groupTotals.discount;
    });
    if (!this.id) {
      // TODO not enough info to update an existing invoice we are editing, so skipping that bit for now
      this.updateMemo();
    }
  };
  Invoice.prototype.groupFromItems = function (groupType, items) {
    var invoice = this;
    splitIntoMatters(name, items, function (groupItems, matter) {
      var detail = new Group(groupType, matter).fromItems(groupItems);
      if (_state.format.summaryAccount && !groupType.noSummary) {
        var summary = new Group(groupType, matter).fromItemsSummary(groupItems);
        invoice.groups.push(summary);
        invoice.detail.push(detail);
      } else {
        invoice.groups.push(detail);
      }
    });
    this.groups = _.sortBy(invoice.groups, g => g.sort);
  };
  Invoice.prototype.groupFromEntries = function (groupType, entries) {
    var invoice = this;
    splitIntoMatters(name, entries, function (groupEntries, matter) {
      var detail = new Group(groupType, matter).fromEntries(groupEntries);
      if (_state.format.summaryAccount) {
        var summary = new Group(groupType, matter).fromEntriesSummary(groupEntries);
        invoice.groups.push(summary);
        invoice.detail.push(detail);
      } else {
        invoice.groups.push(detail);
      }
    });
    this.groups = _.sortBy(invoice.groups, g => g.sort);
  };
  Invoice.prototype.groupFromComputedItems = function (groupType, computed) {
    var invoice = this;
    var items = computed.map(c => new LineItem().fromComputed(c));
    var detail = new Group(groupType).fromItems(items);
    invoice.groups.push(detail);
    this.groups = _.sortBy(invoice.groups, g => g.sort);
  };
  function splitIntoMatters(name, things, matterCallback) {
    if (!_state.format.combineMatters && !_state.init.matter) {
      _.each(_.groupBy(things, i => i.matter ? i.matter.id : null), function (matterThings, matterId) {
        matterCallback(matterThings, matterThings[0].matter);
      });
    } else {
      matterCallback(things, things[0].matter);
    }
  }
  function Entry(entry, onhold) {
    angular.copy(entry, this);
    this.date = new Date(this.startTime);
    this.date = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());
    this.onhold = !!onhold; // might be undefined so making sure it ends up as bool because we use it later to groupBy
    this.amount = calculateEntryAmount(this.rate.amount, this.billedHours);
  }
  Entry.prototype.hold = function () {
    this.onhold = true;
    reload();
  };
  Entry.prototype.hoursToString = function () {
    if (!this.hours || this.billingType == 'fixedFee' && _state.format.fixedHideHours) {
      return '';
    }
    var number = (Math.round(this.billedHours * 100) / 100).toString().replace(/^0/, '');
    return ' (' + number + ')';
  };
  function Expense(e) {
    angular.copy(e, this);
    var parts = e.date.substring(0, 10).split('-');
    this.date = new Date(parts[0], parts[1] - 1, parts[2]);
    return this;
  }
  function Group(groupType, matter) {
    if (!groupType) return this;
    this.name = groupType.name;
    this.sort = '000' + groupType.sort;
    this.matter = matter;
    if (matter && !_state.format.combineMatters && !_state.init.matter) {
      this.name = matter.label + (_state.format.combineTypes ? '' : ' (' + groupType.name + ')');
      this.sort = matter.label + matter.id + groupType.sort;
    }
    return this;
  }
  Group.prototype.fromExisting = function (group) {
    this.name = group.name;
    this.matter = group.matter;
    this.subtotal = group.subtotal;
    return this.fromItems(group.lineItems);
  };
  Group.prototype.fromItems = function (items) {
    function sameDate(a, b) {
      // eslint-disable-next-line eqeqeq
      return b && a && new Date(b).getTime() == new Date(a).getTime();
    }
    function isEntry(a) {
      return a.entries && a.entries.length;
    }
    this.lineItems = items.sort((a, b) => {
      if (isEntry(a) && isEntry(b) && sameDate(a.date, b.date)) {
        // if we have time entries on the same day, sort them by time
        // (always chonological regardless of invoiceSortReverse setting)
        const startTimeDiff = new Date(a.entries[0].startTime) - new Date(b.entries[0].startTime);
        return startTimeDiff || new Date(a.entries[0].created) - new Date(b.entries[0].created);
      }
      return _state.format.invoiceSortReverse ? b.date - a.date : a.date - b.date;
    });
    this.credit = items && !!items.find(i => i.credit);
    this.totals = angular.copy(zeroTotals);
    this.lineItems.forEach(li => {
      if (li.account) {
        const user = _users.find(u => u.id === li.account.id);
        if (user) {
          li.account.initials = user.initials || user.name;
        }
      }
    });
    return this;
  };
  Group.prototype.fromItemsSummary = function (items) {
    var group = this;
    var expenses = group.name.toLowerCase().indexOf('expense') >= 0;
    var itemGroups = _.groupBy(items, i => i.account && !expenses ? i.account.id : null);
    var items = _.map(itemGroups, function (items) {
      return new LineItem().fromLineItems(items, expenses ? group.name : null);
    });
    this.lineItems = _.sortBy(items, i => i.description);
    this.totals = angular.copy(zeroTotals);
    return this;
  };
  Group.prototype.fromEntries = function (entries) {
    var entryGroups = _.groupBy(entries, function (e) {
      if (!_state.format.combine) {
        return e.id;
      }
      return new Date(e.startTime).setHours(0, 0, 0, 0) + e.account.id + e.billingType + e.rate.amount + e.customFlag;
    });
    var items = _.map(entryGroups, function (entries) {
      return new LineItem().fromEntries(entries);
    });
    return this.fromItems(items);
  };
  Group.prototype.fromEntriesSummary = function (entries) {
    var group = this;
    var entryGroups = _.groupBy(entries, e => e.account.id + e.rate.amount);
    var items = _.map(entryGroups, function (entries) {
      var line = new LineItem().fromEntries(entries);
      var account = entries[0].account;
      line.description = account.initials || account.name;
      return line;
    });
    this.lineItems = _.sortBy(items, i => i.description);
    this.totals = angular.copy(zeroTotals);
    return this;
  };
  Group.prototype.updateTotals = function () {
    this.totals.hours.billable = _.reduce(this.lineItems, (sum, i) => {
      i.entries?.forEach(entry => {
        sum += entry.billingType === 'billable' ? entry.hours : 0;
      });
      return sum;
    }, 0);
    this.totals.hours.fixed = _.reduce(this.lineItems, (sum, i) => {
      i.entries?.forEach(entry => {
        sum += entry.billingType === 'fixedFee' ? entry.hours : 0;
      });
      return sum;
    }, 0);
    this.totals.hours.nonBillable = _.reduce(this.lineItems, (sum, i) => {
      i.entries?.forEach(entry => {
        sum += entry.billingType === 'nonBillable' ? entry.hours : 0;
      });
      return sum;
    }, 0);
    this.totals.amount = _.reduce(this.lineItems, (sum, i) => sum + i.amount, 0);
    this.totals.discount = _.reduce(this.lineItems, (sum, i) => sum + (i.discount || 0), 0);
    this.subtotal = this.totals.amount;

    // Update computed line items
    this.lineItems.forEach(li => {
      if (!li.computed) return;

      // li.amount = this.totals.amount * (li.computed[0].servicePercentage * 0.01)
    });

    // Now update the amount again to reflect effects of computed values
    this.totals.amount = _.reduce(this.lineItems, (sum, i) => sum + i.amount, 0);
    return this.totals;
  };
  function LineItem() {
    this.fingerprint = null;
  }
  LineItem.prototype.fromLineItems = function (items, description) {
    var line = this;
    line.expenses = [];
    line.entries = [];
    line.computed = [];
    items.forEach(item => {
      if (item.expenses) line.expenses = line.expenses.concat(item.expenses);
      if (item.entries) line.entries = line.entries.concat(item.entries);
      if (item.computed) line.computed = item.computed.concat(item.computed);
    });
    if (!line.expenses.length) line.expenses = null;
    if (!line.entries.length) line.entries = null;
    this.account = items[0].account;
    this.matter = items[0].matter;
    this.description = description || this.account.name;
    this.fingerprint = 'summary-' + this.description;
    this.amount = _.reduce(items, (sum, i) => sum + i.amount, 0);
    this.date = _.min(items, i => i.date).date;
    if (line.computed.length == 0) {
      line.computed = {};
    }
    return this;
  };
  LineItem.prototype.fromLineItem = function (item) {
    if (item.computed) {
      return this.fromComputed(item.computed[0]);
    }
    if (item.entries) {
      return this.fromEntries(item.entries.map(e => new Entry(e)), item.account);
    }
    if (item.expenses) {
      if (item.expenses.length !== 1) throw 'There is more than one expense!?';
      return this.fromExpense(item.expenses[0], item.account);
    }
    if (item.charges) {
      if (item.charges.length !== 1) throw 'There is more than one charge!?';
      return this.fromCharge(item.charges[0], item.account);
    }
    if (item.computed.length == 0) {
      item.computed = {};
    }
    return item;
  };
  LineItem.prototype.fromFixedFeeMatter = function (matter, entries) {
    this.fingerprint = 'fixed-' + matter.id;
    this.entries = [];
    if (entries) {
      this.assignEntries(entries);
    } else {
      this.matter = matter;
    }
    this.date = new Date(); //TODO fixed fee dates
    this.hours = 1;
    this.billingType = matter.billing?.type === 'hours' ? 'billable' : matter.billing?.type === 'fixed' ? 'fixedFee' : 'nonBillable';
    this.fixed = true;
    this.rate = matter.billing.fixed;
    this.amount = this.rate.amount;
    if (this.rate.description) {
      this.description = this.rate.description + (_state.format.fixedDetail && this.description ? ': ' + this.description : '');
    } else {
      this.description = _me.terms.Services;
    }
    this.setDescription(this.description);
    return this;
  };
  LineItem.prototype.fromComputed = function (computed) {
    Object.assign(this, computed);
    // this.fingerprint = "computed-" + computed.label.replace(/ /g, "-");
    // Last day of current month
    this.date = new Date();
    this.date.setMonth(this.date.getMonth() + 1);
    this.date.setDate(0);
    this.amount = 0.0; // Will be computed later (computed.percentage * invoice amount)

    return this;
  };
  LineItem.prototype.fromExtra = function (extra) {
    this.fingerprint = 'extra-' + extra.matter.id;
    this.description = 'Adjustment for fixed fee limit of ' + extra.limitHours + ' hours';
    this.date = new Date();
    this.matter = matterSummary(extra.matter);
    this.matterNames = extra.matter.label;
    this.hours = extra.hours;
    this.billingType = 'billable';
    this.rate = extra.rate;
    this.amount = extra.amount;
    this.customFlag = extra.customFlag;
    this.entries = [];
    this.fixed = false;
    return this;
  };
  LineItem.prototype.fromExpense = function (expense, account) {
    this.fingerprint = 'expense-' + expense.id;
    this.matter = matterSummary(expense.matter);
    this.date = expense.date;
    this.customFlag = expense.customFlag;
    this.amount = expense.amount;
    this.matterNames = expense.matter?.label;
    this.account = account || expense.account;
    this.attachments = expense.attachments;
    this.hasAttachments = expense.attachments?.length > 0;
    this.accountNames = this.account ? this.account.initials || this.account.name : '';
    this.expenses = [expense];
    this.expense = true;
    if (expense.code && expense.code.id) {
      this.codes = {
        task: expense.code
      };
      this.codeNames = expense.code.id;
    }
    this.setDescription(expense.description, _state.format.includeUserInExpenseDescription);
    return this;
  };
  LineItem.prototype.fromCharge = function (charge, account) {
    this.fingerprint = 'charge-' + charge.id;
    this.matter = matterSummary(charge.matter);
    this.date = charge.date || new Date();
    this.amount = charge.amount;
    this.customFlag = charge.customFlag;
    this.matterNames = charge.matter.label;
    this.account = account || charge.account && angular.copy(charge.account);
    this.accountNames = this.account ? this.account.initials || this.account.name : '';
    this.charges = [charge];
    this.fixed = true;
    if (charge.codes) {
      this.codes = charge.codes;
      this.codeNames = this.codes.activity && this.codes.activity.id ? this.codes.activity.id : '';
      this.codeNames += this.codes.task && this.codes.task.id ? ` ${this.codes.task.id}` : '';
      this.codeNames = this.codeNames.trim();
    }
    var description = charge.description;
    if (charge.recurrence && charge.recurrence.includeDateInDescription) {
      if (charge.recurrence.period == 'week') {
        const startOfThisWeek = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - this.date.getDay());
        const endOfWeek = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - this.date.getDay() + 7);
        description += ' (' + $filter('dateStandard')(startOfThisWeek) + ' - ' + $filter('dateStandard')(endOfWeek) + ')';
      }
      if (charge.recurrence.period == 'month') {
        description += ' (' + this.date.toLocaleString('en-us', {
          month: 'long'
        }) + ' ' + this.date.getFullYear() + ')';
      }
      if (charge.recurrence.period == 'quarter') {
        var m = this.date.getMonth();
        var quarter = m < 4 ? 'Q1' : m < 7 ? 'Q2' : m < 10 ? 'Q3' : 'Q4';
        description += ' (' + quarter + ' ' + this.date.getFullYear() + ')';
      }
      if (charge.recurrence.period == 'year') {
        description += ' (' + this.date.getFullYear() + ')';
      }
    }
    this.setDescription(description);
    return this;
  };
  LineItem.prototype.fromEntries = function (entries, account) {
    this.fingerprint = 'entries-' + _.map(entries, e => e.id).join('/');
    this.assignEntries(entries, account);
    if (entries[0].billingType == 'fixedFee') {
      this.amount = 0;
      this.rate = {
        amount: 0
      };
      if (_state.format.fixedHideHours) {
        this.hours = 0;
      }
    }
    this.setDescription(this.description, _state.format.includeUser);
    return this;
  };
  LineItem.prototype.assignEntries = function (entries, account) {
    this.entries = _.sortBy(entries, e => e.startTime);
    var firstEntry = entries[0];
    this.date = _.min(entries, e => e.date).date;
    this.accountNames = account ? account.initials || account.name : _.unique(_.map(entries, e => e.account.initials || e.account.name)).join('; ');
    this.description = descriptionFromEntries(this.entries, _state.format.combineHours);
    this.combined = entries.length > 1;
    this.hours = round2(_.reduce(entries, (sum, e) => sum + e.billedHours, 0));
    this.amount = round2(_.reduce(entries, (sum, e) => sum + (e.billingType === 'billable' ? e.amount : 0), 0));
    this.rate = firstEntry.rate;
    this.customFlag = firstEntry.customFlag;
    var matterGroups = _.groupBy(entries, e => e.matter.id);
    var matterIds = _.keys(matterGroups);
    this.matterNames = _.map(matterIds, id => matterGroups[id][0].matter.label).join('; ');
    if (matterIds.length == 1) {
      this.matter = matterSummary(matterGroups[matterIds[0]][0].matter);
    }
    this.billingType = firstEntry.billingType;

    // only add codes to item, if all entries have the same codes
    if (firstEntry.codes) {
      var differentTask = _.find(entries, e => {
        if (firstEntry.codes.task) return !e.codes || !e.codes.task || e.codes.task.id !== firstEntry.codes.task.id;
        return !!e.codes.task;
      });
      var differentActivity = _.find(entries, e => {
        if (firstEntry.codes.activity) return !e.codes || !e.codes.activity || e.codes.activity.id !== firstEntry.codes.activity.id;
        return !!e.codes.activity;
      });
      if (!differentTask && !differentActivity) {
        this.codes = firstEntry.codes;
      }
      this.codeNames = this.codes?.activity && this.codes.activity.id ? this.codes.activity.id : '';
      this.codeNames += this.codes?.task && this.codes.task.id ? ` ${this.codes.task.id}` : '';
      this.codeNames = this.codeNames.trim();
    }
    if (!_.find(entries, e => e.account.id !== firstEntry.account.id)) {
      this.account = firstEntry.account;
    }
  };
  function descriptionFromEntries(entries, appendHours) {
    // this is somewhat complex due to patterns that some lawyers use where each entry ends with ';'
    // so "First;" and "Second;" becomes "First (.1); second (.2);"
    if (entries.length == 1) {
      return entries[0].description;
    }
    var description = '';
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      var d = e.description;
      if (i > 0) {
        d = d.charAt(0).toLowerCase() + d.slice(1);
      }
      if (d.charAt(d.length - 1) == ';') {
        d = d.substring(0, d.length - 1) + (appendHours ? e.hoursToString() : '') + ';';
      } else {
        d = d + (appendHours ? e.hoursToString() : '');
      }
      if (description) {
        description += description.charAt(description.length - 1) != ';' ? '; ' : ' ';
      }
      description += d;
    }
    return description;
  }
  function combineDescription(description, includeUser, format, accountNames, matterNames, codeNames, invoice) {
    var pieces = [];
    if (includeUser && accountNames) {
      pieces.push(accountNames);
    }
    if (format.includeMatter && matterNames) {
      pieces.push(matterNames);
    }
    if (format.includeCodes && codeNames) {
      pieces.push(codeNames);
    }
    if (description && description.trim()) {
      pieces.push(description);
    }
    var result = pieces.join(format.separator);
    if (result.length > 4000) {
      if (invoice) {
        invoice.truncated = invoice.truncated ? invoice.truncated + 1 : 1;
      }
      result = result.substring(0, 3990) + ' ...';
    }
    return result;
  }

  // not able to figure out why this is an issue for compiler ??
  LineItem.prototype.setDescription = function (description, includeUser) {
    this.description = combineDescription(description, includeUser, _state.format, this.accountNames, this.matterNames, this.codeNames, _state.invoice);
  };
  LineItem.prototype.reformatDescription = function (format, invoice) {
    format = format || _state.format;
    var description = this.entries ? descriptionFromEntries(this.entries, format) : this.description;
    return combineDescription(description, format.includeUser, format, this.accountNames, this.matterNames, this.codeNames, invoice);
  };
  LineItem.prototype.hold = function () {
    _.each(this.entries, function (e) {
      e.onhold = true;
    });
    reload();
  };
  LineItem.prototype.update = function (update) {
    this.edited = true;
    for (var prop in update) {
      if (update.hasOwnProperty(prop)) {
        this[prop] = update[prop];
      }
    }
    _state.invoice.updateTotals();
  };
  function matterSummary(matter) {
    return matter ? {
      id: matter.id,
      name: matter.name,
      label: matter.label
    } : null;
  }

  // Called every time a filter or format changes. Doesn't reload the data
  // but recreates the invoice (groups etc)
  function reload() {
    try {
      _state.invoice.truncated = false;
      var previous = _state.invoice.groups;
      _state.invoice.groups = [];
      _state.invoice.detail = [];

      // Filter off items that are held for later
      var held = _.groupBy(_state.invoice.entries, e => !!e.onhold);
      var entries = held[false] ? held[false] : [];
      _state.onhold = held[true] ? held[true] : [];
      held = _.groupBy(_state.invoice.expenses, e => !!e.onhold);
      var expenses = held[false] ? held[false] : [];
      held = _.groupBy(_state.init.charges, e => !!e.onhold);
      var charges = held[false] ? held[false] : [];
      _state.onhold = _state.onhold.concat(held[true] ? held[true] : []);
      var billable = entries.filter(e => e.billingType === 'billable');
      var nonBillable = entries.filter(e => e.billingType !== 'billable');

      // Figure out groups
      var fixedFeeItems = [];
      var fixedFeeDetailEntries = [];
      if (_state.init.fixed) {
        _.each(_state.init.fixed, function (f) {
          if (f.include) {
            // split out non-billables related to this matter
            var entryGroups = _.groupBy(nonBillable, e => e.matter.id == f.matter.id);
            nonBillable = entryGroups[false] || [];
            var myNonBillable = entryGroups[true];
            fixedFeeItems.push(new LineItem().fromFixedFeeMatter(f.matter, _state.format.includeNone ? null : myNonBillable));
            if (_state.init.extra && _state.init.extra.include) {
              fixedFeeItems.push(new LineItem().fromExtra(_state.init.extra));
            }
            if (_state.format.includeNone && myNonBillable && myNonBillable.length) {
              fixedFeeDetailEntries = fixedFeeDetailEntries.concat(myNonBillable);
            }
          }
        });
      }
      if (charges) {
        _.each(_state.init.charges, function (f) {
          if (f.include) {
            // split out non-billables related to this matter
            var entryGroups = _.groupBy(nonBillable, e => e.matter.id == f.matter.id);
            nonBillable = entryGroups[false] || [];
            var myNonBillable = entryGroups[true];
            fixedFeeItems.push(new LineItem().fromCharge(f));
            if (_state.init.extra && _state.init.extra.include) {
              fixedFeeItems.push(new LineItem().fromExtra(_state.init.extra));
            }
            if (_state.format.includeNone && myNonBillable && myNonBillable.length) {
              fixedFeeDetailEntries = fixedFeeDetailEntries.concat(myNonBillable);
            }
          }
        });
      }
      if (fixedFeeItems.length) {
        _state.invoice.groupFromItems({
          name: 'Fixed Fee',
          sort: 1,
          noSummary: true // prevents summarizing by timekeeper for this group
        }, fixedFeeItems);
      }
      if (fixedFeeDetailEntries.length) {
        _state.invoice.groupFromEntries({
          name: 'Fixed Fee Detail',
          sort: 2
        }, fixedFeeDetailEntries);
      }
      if (_state.format.includeHours && billable.length) {
        var entries = billable;
        if (_state.format.combineBillable && _state.format.includeNone && nonBillable.length) {
          entries = _.union(billable, nonBillable);
        }
        _state.invoice.groupFromEntries({
          name: _me.terms.Services,
          sort: 3
        }, entries);
      }
      if (_state.format.includeExpenses && expenses.length) {
        _state.invoice.groupFromItems({
          name: 'Expenses',
          sort: 3
        }, _.map(expenses, e => new LineItem().fromExpense(e)));
      }
      if ((!_state.format.combineBillable || !_state.format.includeHours) && _state.format.includeNone && nonBillable.length) {
        _state.invoice.groupFromEntries({
          name: _me.terms.Services + ' (Not Billed)',
          sort: 4
        }, nonBillable);
      }
      if (_state.format.includeComputed) {
        _.each(_state.init.computed, c => {
          let d = new Date();
          d.setMonth(d.getMonth() + 1);
          d.setDate(0);
          const itemsArr = [Object.assign({}, c, {
            date: d
          })];
          _state.invoice.groupFromComputedItems({
            name: 'Fees',
            sort: 5
          }, itemsArr);
        });
      }

      // Now that we've changed, go through and re-apply any edits we might have made
      var changesLost = false;
      _.each(previous, group => group.lineItems.forEach(function (item) {
        if (!item.edited) return;
        var found = findSameItem(_state.invoice.groups, item);
        if (found) {
          found.edited = true;
          found.amount = item.amount;
          found.rate = item.rate;
          found.hours = item.hours;
          found.accountingService = item.accountingService;
          found.description = item.description;
        } else {
          changesLost = true;
        }
      }));
      if (changesLost) {
        bootbox.confirm('Some of the changes you have made will be lost if you do this. Is that ok?', function (result) {
          if (!result) {
            _state.invoice.groups = previous;
          }
        });
      }
      _state.invoice.updateTotals();
    } catch (e) {
      console.error(e);
    }
  }
  function findSameItem(groups, search) {
    return _.find(_.flatten(_.map(groups, g => g.lineItems)), item => search.fingerprint == item.fingerprint);
  }
  function setMatter(id, fixed, charges, extra, computed) {
    if (_state.init.id == id && _state.init.matter) return;
    _state.init = {
      id: id,
      matter: true,
      client: false,
      fixed: fixed,
      charges: charges,
      extra: extra,
      computed: computed
    };
  }
  function setClient(id, fixed, charges, extra, computed) {
    if (_state.init.id == id && _state.init.client) return;
    _state.init = {
      id: id,
      matter: false,
      client: true,
      fixed: fixed,
      charges: charges,
      extra: extra,
      computed: computed
    };
  }
  function clear() {
    _state.invoice.entries.forEach(function (e) {
      e.onhold = false;
    });
    reload();
  }

  // Called to reload the data for the invoice
  // (called once when starting to starting to create invoice)
  function load(query, expenseQuery, me) {
    if (_state.query && query.billable == _state.query.billable && query.id == _state.query.id) {
      return $q.resolve();
    }
    //_state.invoice = new Invoice();
    _state.query = query;
    query.id = _state.init.id;
    query.billed = false;
    expenseQuery.id = _state.init.id;
    expenseQuery.billed = false;
    _state.invoice.invoiceDate = new Date();
    if (!_me.company.settings.invoiceDateCreated) {
      if (_state.query) {
        // hack to set to end of month (client request)
        // first a little date athemetic (the endDate is actually a day later than the user sees, e.g. end of september is 20xx-10-01)
        if (_state.query?.rangeLabel === 'Custom Period') {
          _state.invoice.invoiceDate = new Date(_state.query.endDate);
        } else if (_state.query?.rangeLabel === 'Up to Today') {
          _state.invoice.invoiceDate = new Date();
        } else {
          var date = _state.query.endDate ? new Date(_state.query.endDate) : new Date();
          date.setDate(date.getDate() - 1);
          _state.invoice.invoiceDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        }
      }
    }
    _state.invoice.due = new Date(_state.invoice.invoiceDate.getTime() + 24 * 60 * 60000 * 14);
    var load = [_state.init.matter ? leanLawApi.listMatterEntries(query) : leanLawApi.listClientEntries(query)];
    load.push(_state.init.matter ? leanLawApi.listMatterExpenses(expenseQuery) : leanLawApi.listClientExpenses(expenseQuery));
    load.push(_state.init.matter ? leanLawApi.getMatterBilling(query) : leanLawApi.getClientBilling(query));
    load.push(accountingService.verify(false).then(function () {
      return leanLawApi.getAccountingSettings();
    }).catch(function () {
      return $q.resolve({});
    }));
    load.push(_state.init.matter ? leanLawApi.getMatterAccounting(query) : leanLawApi.getClientAccounting(query));
    return $q.all(load).spread(function (entryList, expenseList, billing, settings, account) {
      // New entries loaded, convert to invoice format
      if (account?.id) {
        _state.invoice.accountBalance = account.balance;
      }
      _state.invoice.entries = _.map(entryList.entries, function (e) {
        var onhold = _state.onhold.some(function (existing) {
          return existing.id == e.id && existing.onhold;
        });
        return new Entry(e, onhold);
      });
      _state.invoice.expenses = _.map(expenseList.expenses, function (e) {
        return new Expense(e);
      });
      _state.invoice.billto = billing.address;
      _state.invoice.ledes = billing.codes && billing.codes.ledes;
      if (settings.invoiceMemo) {
        _state.invoice.memo.note = settings.invoiceMemo;
        _state.invoice.standardMessage = true;
      }
      _state.invoice.customInvoiceNumbers = settings.customInvoiceNumbers;
      reload();
    });
  }
  function save(name, submit, filter, checkboxesChecked) {
    if (_state.invoice.invoiceDate) {
      // strip off time info
      var date = new Date(_state.invoice.invoiceDate);
      _state.invoice.invoiceDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    if (!_state.format.summaryAccountMemo) {
      _state.invoice.memo.showAccountTotals = false;
    }
    var create = {
      name,
      format: _state.format,
      billTo: _state.invoice.billto,
      groups: _state.invoice.groups,
      trust: _state.invoice.trust,
      memo: _state.invoice.memo,
      invoiceDate: _state.invoice.invoiceDate,
      reference: _state.invoice.reference
    };
    if (_state.invoice.detail && _state.invoice.detail.length) {
      create.detail = _state.invoice.detail;
    }
    if (_state.init.matter) {
      create.matter = {
        id: _state.init.id
      };
    }
    if (_state.init.client) {
      create.client = {
        id: _state.init.id
      };
    }
    if (_state.invoice.discount) {
      create.discount = _state.invoice.discount;
    }
    return leanLawApi.createInvoice({
      body: {
        method: 'step-by-step',
        invoice: create,
        filter: {
          startDate: filter.startDate,
          endDate: filter.endDate,
          timeOffset: new Date().getTimezoneOffset(),
          checkboxesChecked: checkboxesChecked
        }
      }
    }).then(invoice => {
      if (submit) {
        return leanLawApi.processInvoice({
          id: invoice.id,
          body: {
            submit: true
          }
        }).then(invoice => {
          onboardService.reload();
          return 'The invoice was created and sent to QuickBooks. If you see any issues you can Undo the invoice which also removes it from QuickBooks.';
        }).catch(err => {
          return $q.reject("The invoice was created but failed to go to QuickBooks - it can be found under 'Drafts' (" + err.body.message + ')');
        });
      }
      onboardService.reload();
      return "Draft invoice was created- it can be found under 'Drafts'";
    });
  }
  function init() {
    // Added this init function, called from editor controller. Before there was an attempt to cache invoices but this resulted in
    // them not being reset correctly and one trust account balance ending on a different invoice. There might be more cleanup to do
    // related to this. The setMatter/setClient function should probably be where the invoice is created initially instead of having
    // all these steps init->setClient->load->reload.
    _state.invoice = new Invoice();
    _state.init = {};
    return _state.invoice;
  }
  return {
    state: _state,
    setClient,
    setMatter,
    setFormat,
    setConfig,
    init,
    load,
    reload,
    save,
    clear,
    LineItem,
    Group,
    trustMemo,
    fromInvoice(invoice) {
      return new Invoice().loadFromInvoice(invoice);
    }
  };
}]);